// supabase.js
import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    // AdminAuthAction.jsx parses recovery-link hashes and calls setSession()
    // itself - the built-in auto-detection was racing it (both processing the
    // same hash independently) and tearing the session back down right after
    // setSession() had just set it up, causing "Auth session missing!" on
    // password save despite the page showing the right account a moment
    // earlier.
    auth: { detectSessionInUrl: false },
  }
);
